import { cn } from '@/shared/lib/utils';
import * as React from 'react';

/** 회색 검색 입력 (M-04 병의원 검색 · M-09 병의원/의약품 검색) */
const SearchInput = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement> & { icon?: React.ReactNode }
>(({ className, icon, ...props }, ref) => (
  <label
    className={cn(
      'flex h-[42px] items-center gap-2 rounded-md bg-field px-3.5',
      className,
    )}
  >
    {icon}
    <input
      ref={ref}
      type="search"
      className="w-full min-w-0 bg-transparent text-[13px] leading-5 text-ink outline-none placeholder:text-ink-8"
      {...props}
    />
  </label>
));
SearchInput.displayName = 'SearchInput';

export { SearchInput };
